import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import _ from 'lodash';

import { MultiHouseCalendarService } from '@root/router/house/component/multi-house-calendar/multi-house-calendar.service';
import { OrderV2Service } from '@root/router/order-v2/order-v2.service';
import { HouseOrderGuestService } from './house-order-guest/house-order-guest.service';
import {
  SwitchPageService,
  PAGES_NAME,
  PageName,
} from '@root/router/component/order-detail-sidebar/switch-page.service';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'host-house-order-detail',
  templateUrl: './house-order-detail.component.html',
  styleUrls: ['./house-order-detail.component.scss'],
})
export class HouseOrderDetailComponent implements OnInit, OnChanges, OnDestroy {
  @Input() code;
  @Input() activatedIndex = 0;
  @Input() pageType: 'sidebar' | 'modal' = 'sidebar';
  @Input() backArrow = false;
  orderDetail;
  loading = false;
  /** @deprecated */
  showBackArrow = _.get(this.switchPageService.currentNode, 'element.showBack');
  selectedIndex = null;

  private currentOrderPageRaw$ = this.switchPageService.currentNodeRaw$.pipe(
    tap((value) => {
      if (
        _.get(value, 'refresh') &&
        _.get(value, 'page') === PAGES_NAME.ORDER_DETAIL_GUEST
      ) {
        this.getdetail();
        // this.calendarService.refresh();
      }
    })
  );

  private destroy$ = new Subject();

  constructor(
    private orderService: OrderV2Service,
    private calendarService: MultiHouseCalendarService,
    private guestService: HouseOrderGuestService,
    private switchPageService: SwitchPageService
  ) {}

  ngOnInit() {
    this.currentOrderPageRaw$.pipe(takeUntil(this.destroy$)).subscribe();
    if (this.pageType !== 'sidebar') {
      this.getdetail();
    }
    this.getOptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['code'] && changes['code'].currentValue) {
      console.log(this.code);
      this.getdetail();
      // this.getPageAndDataForJump();
    }
  }

  /** @deprecated */
  getPageAndDataForJump() {
    const nodeTab = _.get(this.switchPageService.currentNode, 'element.tab');
    const nodeActivedTab = nodeTab === 0 ? 0 : nodeTab ? nodeTab : null;
    this.activatedIndex = nodeActivedTab || this.selectedIndex || 0;
    if (
      this.activatedIndex === 2 &&
      (this.switchPageService.biao.length === 0 ||
        this.switchPageService.currentNode.element.page ===
          PAGES_NAME.ORDER_DETAIL_BASIC)
    ) {
      this.guestService.updateOrderGuestListRefresh({
        refresh: true,
        code: this.code,
      });
    }
    this.getdetail();
    this.showBackArrow = _.get(
      this.switchPageService.currentNode,
      'element.showBack'
    );
  }

  checkTab(index) {
    this.selectedIndex = index;

    if (this.pageType === 'sidebar') {
      this.switchPageService.navigate(PageName.OrderDetail, { index });
    }
  }

  getOptions() {
    this.orderService.getSettings().subscribe((res) => {
      if (res.error_code === 0) {
        const settingOptions = _.get(res, 'data');
        this.orderService.gethouseStatusSettingOptions().emit(settingOptions);
      }
    });
  }

  getdetail() {
    this.loading = true;
    this.orderService
      .getOrderDetail({
        reservation_code: this.code,
        format: 'v_2',
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.orderDetail = res.data.reservation;
        }
      });
  }

  refreshModal(e) {
    if (e) {
      this.getdetail();
      this.orderService.updateOrderListRefresh(true);
      this.calendarService.refresh();
    }
  }

  changeOrder(message) {
    this.code = message.code;
    this.getdetail();
  }

  back() {
    this.switchPageService.go(0);

    const params = {
      house: {
        id: _.get(this.orderDetail, 'house_id'),
        house_title: _.get(this.orderDetail, 'house_title'),
      },
      date: _.get(this.orderDetail, 'check_in'),
    };
    this.calendarService.displayHourReservationSidebar(params);
  }

  /** @deprecated */
  JumpBack() {
    if (
      this.switchPageService.biao.head.element.page ===
      PAGES_NAME.HOUR_ORDER_DETAIL_BASIC
    ) {
      this.calendarService.cancelSelectReservation();
      this.switchPageService.destroyCurrentLianBiao();

      const params = {
        house: {
          id: _.get(this.orderDetail, 'house_id'),
          house_title: _.get(this.orderDetail, 'house_title'),
        },
        date: _.get(this.orderDetail, 'check_in'),
      };
      this.calendarService.displayHourReservationSidebar(params);
    } else {
      this.switchPageService.deleteNodeAndUpdateCurrentNode();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
